import { StateToken } from '@ngxs/store';

export const GOALS_STATE_TOKEN = new StateToken<GoalsStateModel>('goals');

export interface GoalsStateModel {
  refreshOnManageCampaignsClose: boolean;
}
